// Find existing topics.
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { Tinode } from 'tinode-sdk';

import ChatLoadingView from '../widgets/chat-loading-view.jsx';
import ChatNoAccessView from '../widgets/chat-no-access-view.jsx';
import ContactList from '../widgets/contact-list.jsx';
import SearchContacts from '../widgets/search-contacts.jsx';

import HashNavigation from '../lib/navigation.js';

const messages = defineMessages({
  search_for_contacts: {
    id: "search_for_contacts",
    defaultMessage: "Search by trip tag: aks_trip_dr:TRIP_ID-DRIVER_ID",
    description: "Text shown in contacts view when user entered no search query."
  },
  search_no_results: {
    id: "search_no_results",
    defaultMessage: "Search returned no results",
    description: "Text shown in contacts view when query returned no results."
  },
  search_placeholder: {
    id: "search_placeholder",
    defaultMessage: "aks_trip_dr:TRIP_ID-DRIVER_ID",
    description: "Placeholder in contacts search field"
  },
});

// Find tab is restricted to users whose trusted badges include both verified AND staff.
function hasFindAccess(trustedBadges) {
  return Array.isArray(trustedBadges) &&
    trustedBadges.includes('verified') &&
    trustedBadges.includes('staff');
}

class NewTopicView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchQuery: null
    };

    this.handleSearchContacts = this.handleSearchContacts.bind(this);
    this.handleSearchResultSelected = this.handleSearchResultSelected.bind(this);
  }

  componentDidMount() {
    if (hasFindAccess(this.props.trustedBadges)) {
      HashNavigation.navigateTo(HashNavigation.addUrlParam(window.location.hash, 'tab', 'find'));
      this.props.onInitFind();
    }
  }

  componentDidUpdate(prevProps) {
    const hadFindAccess = hasFindAccess(prevProps.trustedBadges);
    const hasAccess = hasFindAccess(this.props.trustedBadges);
    if (!hadFindAccess && hasAccess) {
      HashNavigation.navigateTo(HashNavigation.addUrlParam(window.location.hash, 'tab', 'find'));
      this.props.onInitFind();
    }
  }

  handleSearchContacts(query) {
    this.props.onSearchContacts(query);
    this.setState({searchQuery: Tinode.isNullValue(query) ? null : query});
  }

  handleSearchResultSelected(topicName) {
    HashNavigation.navigateTo(HashNavigation.addUrlParam(window.location.hash, 'tab', 'find'));
    this.props.onCreateTopic(topicName);
  }

  render() {
    const {formatMessage} = this.props.intl;
    const canFind = hasFindAccess(this.props.trustedBadges);
    const no_contacts_placeholder = formatMessage(this.state.searchQuery ?
      messages.search_no_results : messages.search_for_contacts);
    const search_placeholder = formatMessage(messages.search_placeholder);
    const restrictedContent = this.props.trustedBadgesReady ?
      <div className="panel-form-row chat-no-access-form">
        <ChatNoAccessView />
      </div> :
      <div className="panel-form-row chat-loading-form">
        <ChatLoadingView />
      </div>;

    return (
      <div className="flex-column">
        {canFind ?
          <div className="flex-column">
            <SearchContacts
              placeholder={search_placeholder}
              onSearchContacts={this.handleSearchContacts} />
            <ContactList
              tinode={this.props.tinode}
              contacts={this.props.searchResults}
              myUserId={this.props.myUserId}
              emptyListMessage={no_contacts_placeholder}
              showOnline={false}
              showUnread={false}
              showContextMenu={false}
              onTopicSelected={this.handleSearchResultSelected} />
          </div> :
          restrictedContent}
      </div>
    );
  }
};

export default injectIntl(NewTopicView);
